import { createSimulationServices } from '@exodus/web3-simulation';
import assert from 'minimalistic-assert';
export const createSolanaDepsFactory = ({ assetClientInterface, }) => {
    return ({ getActiveWalletAccountData, getWalletAccountsData, getAddress, getAddressByWalletAccount, getRecentBlockHash, sendRawTransaction: _sendRawTransaction, simulationAPIBaseURL, transactionSigner, messageSigner, }) => {
        const getPublicKey = async (walletAccount) => {
            if (walletAccount) {
                assert(getAddressByWalletAccount, 'getPublicKey: getAddressByWalletAccount is required when walletAccount is provided');
                const address = await getAddressByWalletAccount('solana', walletAccount);
                return { toBase58: () => address };
            }
            const address = await getAddress('solana');
            return { toBase58: () => address };
        };
        const getLatestBlockhash = (commitment) => getRecentBlockHash(commitment);
        const sendRawTransaction = (rawTransaction, options) => {
            return _sendRawTransaction('solana', Buffer.from(rawTransaction).toString('base64'), options);
        };
        const { simulateSolanaTransactions } = createSimulationServices({
            apiBaseURL: simulationAPIBaseURL,
            assetClientInterface,
        });
        return {
            getActiveWalletAccountData,
            getWalletAccountsData,
            getPublicKey,
            getLatestBlockhash,
            sendRawTransaction,
            simulateSolanaTransactions,
            messageSigner,
            transactionSigner,
        };
    };
};
